export enum SidenavSide {
  RIGHT = 'right',
  LEFT = 'left',
}

export enum OpenableMenu {
  SIDENAV = 'sidenav',
  SETTINGS = 'settings',
  CHATBOT = 'chatbot',
}

export interface SideOpenableMenu {
  position: SidenavSide;
  menuType: OpenableMenu;
}

export enum SidenavPanel {
  SHARE = 'Share',
  DASHBOARDS = 'Dashboards',
  FILTERS = 'Filters',
  NAVIGATION = 'Navigation',
  FAVORITE = 'Favorite',
  NEWS = 'News',
  INSIGHTS = 'Insights',
}
